import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Input, signal } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { IconComponent } from '@design-system/buttons/icon/icon.component';
import { TestIdDirective } from '@design-system/core/test-id.directive';
import { InputComponent } from '@design-system/forms/input/input.component';
import { InputType } from '@design-system/forms/input/input.component';

@Component({
  selector: 'app-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    InputComponent,
    IconComponent,
    TestIdDirective
  ]
})
export class PasswordInputComponent {
  @Input() formPropertyName!: string;
  @Input() placeholder!: string;
  @Input() label!: string;
  @Input() requiredField!: boolean;
  @Input() minLength!: number;
  @Input() tid = '';

  readonly passwordType = signal<InputType>('password');
  readonly passwordIcon = signal('visibility_off_outline');

  constructor(
    private elementRef: ElementRef,
    private formGroupDirective: FormGroupDirective
  ) {}

  togglePasswordVisibility() {
    if (this.passwordType() === 'password') {
      this.passwordType.set('text');
      this.passwordIcon.set('visibility_outline');
    } else {
      this.passwordType.set('password');
      this.passwordIcon.set('visibility_off_outline');
    }
  }
}
